import { Injectable } from "@angular/core";
import { HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";

import { SubjectModel, SubjectModelListItem, SubjectModelNew, SubjectModelUpdate, SubjectModelClone } from "../../_objects/subject-model";
import { ApiService } from "../base/api-base.service";
import { SubjectModelContractService } from "../interfaces/subject-model-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { SubjectModelOnlineService } from "../online/subject-model-online.service";
import { SubjectModelOfflineService } from "../offline/subject-model-offline.service";

@Injectable()
export class SubjectModelService extends ApiService<SubjectModelContractService> implements SubjectModelContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: SubjectModelOfflineService,
    protected onlineService: SubjectModelOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // MD01 GET /api/v1/models
  getSubjectModels(enabledOnly?: boolean, aliveOnly?: boolean): Observable<SubjectModelListItem[]> {
    return this.service.getSubjectModels(enabledOnly, aliveOnly);
  }

  // MD02 GET /api/v1/models/{modelId}
  getSubjectModel(id: string, version?: number, enabledOnly?: boolean, aliveOnly?: boolean): Observable<SubjectModel> {
    return this.service.getSubjectModel(id, version, enabledOnly, aliveOnly);
  }

  // MD03 POST /api/v1/models
  addSubjectModel(subjectModel: SubjectModelNew): Observable<SubjectModel> {
    return this.service.addSubjectModel(subjectModel);
  }

  // MD04 PUT /api/v1/models/{modelId}
  updateSubjectModel(updateModel: SubjectModelUpdate): Observable<any> {
    return this.service.updateSubjectModel(updateModel);
  }

  // MD05 GET /api/v1/models/{modelId}/export
  exportSubjectModel(id: string): Observable<Blob> {
    return this.service.exportSubjectModel(id);
  }

  // MD06 POST /api/v1/models/import
  importSubjectModel(file: File): Observable<HttpEvent<{}>> {
    return this.service.importSubjectModel(file);
  }

  // MD07 PUT /api/v1/models/{modelId}/image
  updateSubjectModelImage(modelId: string, file: File): Observable<HttpEvent<{}>> {
    return this.service.updateSubjectModelImage(modelId, file);
  }

  // MD08 PUT /api/v1/models/{modelId}
  deleteSubjectModel(modelId: string): Observable<HttpEvent<{}>> {
    return this.service.deleteSubjectModel(modelId);
  }

  // MD09 POST /api/v1/models/{modelId}/clone
  cloneSubjectModel(cloneModel: SubjectModelClone): Observable<any> {
    return this.service.cloneSubjectModel(cloneModel);
  }
}
